/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import { Frame } from "../frames/frame"
import { commonTranslations } from "../translations/silos"
import { SchemaPropertyMap } from "../utils/legacy/i-schema-property"
// const MAX_RECORDS = 10000

const subreadBaseProperties: SchemaPropertyMap = {
    name: {
        title: commonTranslations.name,
        description: "",
        type: "string",
        idField: "id",
        /* eslint no-template-curly-in-string: "off" */
            url: "/data-management/dataset-detail/${id}?type=subreads" // type = DatasetType.SUBREAD.shortName
    },
    wellSampleName: {
        title: commonTranslations.wellSampleName,
        description: "",
        type: "string"
    },
    bioSampleName: {
        title: commonTranslations.bioSampleName,
        description: "",
        type: "string"
    },
    dnaBarcodeName: {
        title: commonTranslations.dnaBarcodeName,
        description: "",
        type: "string"
    },
    cellIndex: {
        title: commonTranslations.cellIndex,
        description: "",
        type: "integer"
    },
    cellId: {
        title: commonTranslations.cellId,
        description: "",
        type: "string"
    },
    updatedAt: {
        title: commonTranslations.updatedAt,
        description: "",
        type: "string",
        format: "date-time"
    },
    numRecords: {
        title: commonTranslations.numSubreads,
        description: "",
        type: "integer"
    },
    totalLength: {
        title: commonTranslations.totalLengthSubreads,
        description: "",
        type: "integer"
    },
    createdAt: {
        title: commonTranslations.createdAt,
        description: "",
        type: "string",
        format: "date-time"
    },
    id: {
        title: commonTranslations.id,
        description: "",
        type: "string"
    },
    uuid: {
        title: commonTranslations.uuid,
        description: "",
        type: "string"
    },
    path: {
        title: commonTranslations.path,
        description: "",
        type: "string"
    },
    runName: {
        title: commonTranslations.runName,
        description: "",
        type: "string"
    },
    plateId: {
        title: commonTranslations.plateId,
        description: "",
        type: "string"
    },
    instrumentName: {
        title: commonTranslations.instrumentName,
        description: "",
        type: "string"
    },
    wellName: {
        title: commonTranslations.wellName,
        description: "",
        type: "string"
    },
    metadataContextId: {
        title: commonTranslations.metadataContextId,
        description: "",
        type: "string"
    },
    tags: {
        title: commonTranslations.tags,
        description: "",
        type: "string"
    },
    projectId: {
        title: commonTranslations.projectId,
        description: "",
        type: "integer"
    },
    jobId: {
        title: commonTranslations.jobId,
        description: "",
        type: "integer"
    },
    version: {
        title: commonTranslations.version,
        description: "",
        type: "string"
    },
    md5: {
        title: commonTranslations.md5,
        description: "",
        type: "string"
    },
    createdBy: {
        title: commonTranslations.createdBy,
        description: "",
        type: "string"
    },
    comments: {
        title: commonTranslations.comments,
        description: "",
        type: "string"
    }
}

const childProperty: SchemaPropertyMap  =  {
    numChildren: {
        title: commonTranslations.numChildren,
        description: "",
        type: "integer",
        canHaveHighlight: true
    }
}

const childSubreadProperties = Object.assign({}, subreadBaseProperties)
const subreadProperties = Object.assign(childProperty, subreadBaseProperties)

export const SUBREAD_FRAME = new Frame({
    endpoint: undefined, // API.nDatasets.and({$set_type: "subreads"}),
    properties: subreadProperties
})

export const CHILD_SUBREAD_FRAME = new Frame({
    endpointFunction: undefined, /* (parentUuid: string) => API.nDatasets.and(
        {$set_type: "subreads", parentUuid: parentUuid, limit: MAX_RECORDS }), */
    properties: childSubreadProperties
})

export const PARENT_SUBREAD_FRAME = new Frame({
    endpoint: undefined, // API.nDatasets.and({$set_type: "subreads", parentUuid: "null", limit: MAX_RECORDS}),
    properties: subreadProperties
})

export const FLATTENED_SUBREAD_FRAME = new Frame({
    endpoint: undefined, // API.nDatasets.and({$set_type: "subreads", limit: MAX_RECORDS}),
    properties: subreadBaseProperties
})
